import { css } from '@emotion/react';

export const container = css`
  display: flex;
  align-items: flex-start;
  padding: 20px;
  border-radius: 4px;
  gap: 20px;
`;

export const text = css`
  flex: 1;
`;
